import React, { useState, useEffect } from 'react';
import { Table, Button,
  Spin
 } from 'antd';
import { createNewBBS} from '../../redux/slice';

import { useSelector, useDispatch } from 'react-redux';
import { data } from 'autoprefixer';
import LocalStorage from '../../../../utilities/localStorage.js'

const DashboardCreateTable = ({ columns ,searchQuery }) => {
  const dispatch = useDispatch();
  const { newBBSData,loading ,newBBSpagination} = useSelector((state) => state.projectList);
  const user_details = LocalStorage.getItem('bbs_user');
  const[currpage,setCurrPage]=useState(1)
  const [isLoading, setIsLoading] = useState(loading);

  

  const handlePageChange = (type) => {
    if (type === 'next' && currpage < newBBSpagination?.totalPages) {
      setCurrPage(currpage + 1);
    } else if (type === 'prev' && currpage > 1) {
      setCurrPage(currpage - 1);
    }
  };

 useEffect(() => {
     if (user_details?.user?.id) {
       const payload = {
         userId: user_details?.user?.id, // Use the actual user ID here
         page: currpage,
         search: searchQuery,  
         
       };
       dispatch(createNewBBS(payload));
     }
   }, [dispatch, user_details?.user?.id,currpage,searchQuery]);


   useEffect(() => {
     if (loading) {
       // Show the loader for at least 1 second
       const timer = setTimeout(() => {
         setIsLoading(false);
       }, 2000);
 
       return () => clearTimeout(timer); // Cleanup
     } else {
       setIsLoading(false);
     }
   }, [loading]);

  console.log('pagination totapages: ',newBBSpagination?.totalPages)
const dataSource=newBBSData||[]
  // Calculate total pages based on totalItems and pageSize
  //const totalPages = Math.ceil(pagination.total / pagination.pageSize);

  console.log('datasourcetable: ',dataSource)
  return (
    <div className="dashboard-table-container">
      <div className="table-wrapper">
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
         // rowKey={(record) => record.key} 
          loading={{
            spinning: loading, // Spinner controlled by Redux loading state
            indicator: <Spin size="large" />, // Custom large spinner
          }} // Disable default Ant Design pagination

        />
      </div>

      <div className="pagination-controls flex items-center justify-between mt-4">
        {/* Display Current Page Info */}
        <div className="page-info text-gray-600">
          Page {currpage} of {newBBSpagination?.totalPages}
        </div>

        {newBBSpagination?.totalPages > 1 && (
        <div className="pagination-buttons">
          <Button
            disabled={currpage === 1}
            onClick={() => handlePageChange("prev")}
            style={{
              backgroundColor: '#FFFFFF',
              color: '#344054',
              borderStyle: 'solid',
              borderRadius: '8px',
              borderColor: '#D0D5DD',
            }}
          >
            Previous
          </Button>
          <Button
            disabled={currpage === newBBSpagination?.totalPages}
            onClick={() => handlePageChange("next")}
            style={{
              marginLeft: '8px',
              backgroundColor: '#FFFFFF',
              color: '#344054',
              borderStyle: 'solid',
              borderRadius: '8px',
              borderColor: '#D0D5DD',
            }}
          >
            Next
          </Button>
        </div>
        )}
      </div>
    </div>
  );
};

export default DashboardCreateTable;